export default {
      id: "i-calendar3-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/sprite.svg#i-calendar3",
      toString: function () {
        return this.url;
      }
    }